import * as React from 'react';
import { FC } from 'react';

import { FeatureEmptyState } from 'components/features/components/empty-state';

import { LoyaltyLoader } from '../loyalty-loader';

import { Container, LoadingContainer, Padding } from './loyalty-no-reward-points.styled';
import { useFeaturesLoyaltyNoReward } from './use-features-loyalty-no-reward';

interface ILoyaltyNoRewardPointsProps {
  className?: string;
}

const LoyaltyNoRewardPoints: FC<ILoyaltyNoRewardPointsProps> = ({ className }) => {
  const { data, loading } = useFeaturesLoyaltyNoReward();

  if (loading) {
    return (
      <LoadingContainer>
        <LoyaltyLoader />
      </LoadingContainer>
    );
  }
  if (!data || !data?.noRewardPoints) {
    return null;
  }
  return (
    <Container className={className}>
      <FeatureEmptyState content={data.noRewardPoints} showCTA={false} />
      {/* explicit padding element needed for safari */}
      <Padding />
    </Container>
  );
};

export default LoyaltyNoRewardPoints;
